import type { LoginMutation } from '@/components/auth/hooks/useAuthenticate/useLogin/useLogin.generated';
import { useSetPreferredPlatform } from '@/hooks/useSetPreferredPlatform';
import { isPinnable, isPlatformType } from '@/utils/platformLib';
import { usePinChangeTip } from '../../hooks/usePinChangeTip';

type Options = {
  platform?: string | undefined;
  onComplete?: () => void;
  user?: LoginMutation['login'];
};

export const useHandleAuthenticate = () => {
  const { setPreferredPlatform } = useSetPreferredPlatform();
  const { trigger: triggerPinChangeTip } = usePinChangeTip();

  const handleAuthenticate = ({ platform, onComplete, user }: Options) => {
    if (
      !user?.preferredPlatform &&
      isPlatformType(platform) &&
      isPinnable(platform)
    ) {
      setPreferredPlatform(platform, {
        onSuccess: () => triggerPinChangeTip(null, platform),
        onSettled: () => onComplete?.(),
      });
    } else {
      onComplete?.();
    }
  };

  return { handleAuthenticate };
};
